import React, { useState, useEffect } from "react";
import { TextField, Button, Typography, Container, Box } from "@mui/material";
import Layout from "../../../layout/Layout";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Link } from "react-router-dom";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  addCategory,
  getCategory,
  editCategory,
} from "../../../services/coworking/categoryApi";

const AddEditCoworkingCategory = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  let location = useLocation();
  location = location.pathname.slice(1);

  const isEditMode = location === "add-new-coworking-category" ? false : true;

  const [categoryData, setCategoryData] = useState({
    name: "",
    description: "",
  });

  useEffect(() => {
    if (id) {
      getCategory(id)
        .then((data) => {
          setCategoryData({
            name: data.name,
            description: data.description,
          });
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [id]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCategoryData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const newCategoryData = {
      name: categoryData.name,
      description: categoryData.description,
    };
    if (isEditMode) {
      editCategory(id, newCategoryData)
        .then((response) => {
          setCategoryData({
            name: "",
            description: "",
          });

          navigate("/coworking-category");
        })
        .catch((error) => {
          console.error("Greška pri ažuriranju:", error);
        });
    } else {
      addCategory(newCategoryData)
        .then((response) => {
          setCategoryData({
            ...categoryData,
            name: response.name,
            description: response.description,
          });
          navigate("/coworking-category");
        })
        .catch((error) => {
          console.error("Greška pri dodavanju", error);
        });
    }
  };

  const handleBack = () => {
    // Handle Back action here
  };

  return (
    <Layout>
      <div>
        <Box style={{ display: "flex" }}>
          <Link to="/coworking-category" style={{ textDecoration: "none" }}>
            <Button variant="outlined" onClick={handleBack}>
              <ArrowBackIcon />
              Back
            </Button>
          </Link>
        </Box>
        <Typography variant="h4" gutterBottom sx={{ textAlign: "center" }}>
          Coworking Category
        </Typography>

        <form onSubmit={handleSubmit}>
          <div>
            <TextField
              sx={{ marginTop: "30px" }}
              name="name"
              label="Name"
              value={categoryData.name}
              fullWidth
              onChange={handleInputChange}
            />
          </div>

          <div>
            <TextField
              sx={{ marginTop: "30px" }}
              name="description"
              label="Description"
              multiline
              rows={6}
              value={categoryData.description}
              fullWidth
              onChange={handleInputChange}
            />
          </div>

          <Container
            sx={{
              marginTop: "30px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Button
              sx={{ m: 1, width: "25ch" }}
              type="submit"
              size="medium"
              variant="outlined"
            >
              {location === "add-new-coworking-category" ? "Publish" : "Save"}
            </Button>
          </Container>
        </form>
      </div>
    </Layout>
  );
};

export default AddEditCoworkingCategory;
